import store from "../../../store";
import { acrylicStandId, noStandId } from "../../../../config";
import { empty } from "../../../../helpers";

export default function useDiscountCoupon() {
  const SK_NON_ACRYLIC_DISCOUNT = 6956;

  const CZ_NON_ACRYLIC_DISCOUNT = 6957;

  const HU_NON_ACRYLIC_DISCOUNT = 6958;

  const NON_ACRYLIC_DISCOUNT_IDS = [
    SK_NON_ACRYLIC_DISCOUNT,
    CZ_NON_ACRYLIC_DISCOUNT,
    HU_NON_ACRYLIC_DISCOUNT,
  ];

  function getDiscount() {
    return store.getters["discountCoupon/getData"];
  }

  function getNonAcrylicDiscountData() {
    const { lang } = document.documentElement;

    if (lang === "sk") {
      return {
        name: "1+1 ZADARMO",
        value: 39.9,
        id: SK_NON_ACRYLIC_DISCOUNT,
      };
    }
    if (lang === "cs") {
      return {
        name: "1+1 ZDARMA",
        value: 989,
        id: CZ_NON_ACRYLIC_DISCOUNT,
      };
    }

    return {
      name: "1+1 INGYENES",
      value: 15900,
      id: HU_NON_ACRYLIC_DISCOUNT,
    };
  }

  function applyDiscountCoupon(data) {
    const discountCouponInput = document.querySelector(
      "#discount-coupon-input"
    );

    const commitMethod = "discountCoupon/SET_DATA";

    store.commit(commitMethod, data);

    if (discountCouponInput) {
      discountCouponInput.value = "";
    }
  }

  function getNonAcrylicCount() {
    const { products } = store.getters["cart/getCartData"];

    const nonAcrylicProduct = products.filter(
      (product) =>
        product.attribute_values.stand &&
        product.attribute_values.stand.id != acrylicStandId &&
        product.attribute_values.stand.id != noStandId
    );

    return nonAcrylicProduct.reduce((acc, product) => acc + product.qty, 0) > 1;
  }

  function checkDiscountCoupon(event) {
    const formData = new FormData(event.target);
    const dispatchMethod = "discountCoupon/CHECK_DISCOUNT_COUPON";

    event.preventDefault();

    store.dispatch(dispatchMethod, formData).then((response) => {
      applyDiscountCoupon(response.data.discount_coupon);
    });
  }

  // getting discount value - percentual and fixes
  function getDiscountCouponPrice(price) {
    const discountCoupon = getDiscount();

    if (discountCoupon) {
      const value = Number(discountCoupon.value);

      if (discountCoupon.is_percent) {
        // percentual
        price = (price / 100) * value;
      } else {
        // fix
        price = value;
      }
    }

    return Number(price);
  }

  function clearDiscountCoupon() {
    const commitMethod = "discountCoupon/SET_DATA";

    store.commit(commitMethod, undefined);
  }

  // apply, if customer doesnt have discount and has 2 or more non acrylic stands of glasses
  function applySpecialDiscount() {
    const discountCoupon = getDiscount();

    const nonAcrylicCount = getNonAcrylicCount();

    const nonAcrylicDiscountCoupon = getNonAcrylicDiscountData();

    if (empty(discountCoupon)) {
      if (nonAcrylicCount) {
        // apply
        applyDiscountCoupon(nonAcrylicDiscountCoupon);
      }
    } else {
      // !nonAcrylicCount && has discount on it - delete discount
      if (
        !nonAcrylicCount &&
        NON_ACRYLIC_DISCOUNT_IDS.includes(discountCoupon.id)
      ) {
        // clear discount
        clearDiscountCoupon();
      }
    }
  }

  return {
    getDiscountCouponPrice,
    checkDiscountCoupon,
    applySpecialDiscount,
  };
}
